import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../../utils/request';
import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const FilterByDealership = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByDealershipUsersFilter }
  } = localizedStrings;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await request.get('/dealerships');
      if (result) {
        const transformedResult = _.get(result, 'data.rows', []).map(item => ({
          label: item.name,
          value: item.id
        }));
        setOptions(transformedResult);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <MultiSelect
        updateFilters={value => {
          setFilters({ ...filters, dealership: value });
        }}
        label={filterByDealershipUsersFilter}
        options={options}
        value={filters.dealership}
      />
    </div>
  );
};

FilterByDealership.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByDealership;
